import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import CustomerRefundTable from "./Components/CustomerRefundTable";
import { NavLink } from "react-router-dom";


/**
 * CustomerRefundList
 * Main page for the Customer Refund module.
 * Lists all customers who have an available balance > 0.
 * Refund is processed inline via the RefundModal triggered from the table.
 */
const CustomerRefundList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Customers with available balance</HeadingOne>
          {/* Info badge showing purpose of this page */}
          <NavLink rel="stylesheet" to="/refund-history" className="btn btn-primary " replace={true}>All Refund History </NavLink>
        </>
      }
    >
      {/* Table section */}
      <div className="col-12">
        <CustomerRefundTable />
      </div>
    </PageBody>
  );
};

export default CustomerRefundList;
